import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const AutoUpdatesRecord = Record({
  isUpdateAvailable: false,
  isDownloading: false,
  didDownloadFail: false,
  isReadyToInstall: false,
  isOutsideApplications: false,
  currentShell: null,
  currentEditor: null,
  currentReader: null,
  availableEditor: null,
  availableReader: null,
  availableReleaseNotes: null,
  isReleaseNotesNew: false,
  showUpdateModal: false,
  useAppStore: false,
  isChecking: false,
  isEditingUpdateAvailable: false,
  isReadonlyUpdateAvailable: false,
  updateRequiresShellUpdate: false
});

// Custom implementation to force numbers to boolean, since they will have been broken
createFromJS.registerCallback("AutoUpdatesRecord", any => {
  return new AutoUpdatesRecord(any).merge({
    isUpdateAvailable: Boolean(any.isUpdateAvailable),
    isDownloading: Boolean(any.isDownloading),
    didDownloadFail: Boolean(any.didDownloadFail),
    isReadyToInstall: Boolean(any.isReadyToInstall),
    isOutsideApplications: Boolean(any.isOutsideApplications),
    showUpdateModal: Boolean(any.showUpdateModal),

    isChecking: Boolean(any.isChecking),
    isEditingUpdateAvailable: Boolean(any.isEditingUpdateAvailable),
    isReadonlyUpdateAvailable: Boolean(any.isReadonlyUpdateAvailable),
    updateRequiresShellUpdate: Boolean(any.updateRequiresShellUpdate),
    isReleaseNotesNew: Boolean(any.isReleaseNotesNew)
  });
});
